module.exports = __webpack_public_path__ + "static/media/md-jet.4af3957c.svg";